import * as moment from "moment"
import { DateSlices } from "./dateSlices"

export class DateRanges {

    id!: string;
    name!: string;
    params: any;
    slice: DateSlices;
    start: Date;
    span: number;

    constructor(id: string, name: string, params: any, slice: DateSlices, start: Date, span: number) {
        this.id = id;
        this.name = name;
        this.params = params;
        this.slice = slice;
        this.start = start
        this.span = span;
    }

    // Values
    static readonly TODAY = new DateRanges('0', 'Today', {
        startDate: moment().startOf('date').toISOString(),
        endDate: moment().endOf('date').toISOString()
    }, DateSlices.day, moment().startOf('date').toDate(), 1);
    static readonly THIS_WEEK = new DateRanges('1', 'This week', {
        startDate: moment().startOf('isoWeek').toISOString(),
        endDate: moment().endOf('isoWeek').toISOString()
    }, DateSlices.day, moment().startOf('isoWeek').toDate(), 7);
    static readonly LAST_WEEK = new DateRanges('2', 'Last week', {
        startDate: moment().subtract(1, 'week').startOf('isoWeek').toISOString(),
        endDate: moment().subtract(1, 'week').endOf('isoWeek').toISOString()
    }, DateSlices.day, moment().subtract(1, 'week').startOf('isoWeek').toDate(), 7);
    static readonly THIS_MONTH = new DateRanges('3', 'This month', {
        startDate: moment().startOf('month').toISOString(),
        endDate: moment().endOf('month').toISOString()
    }, DateSlices.day, moment().startOf('month').toDate(), moment().daysInMonth());
    static readonly LAST_MONTH = new DateRanges('4', 'Last month', {
        startDate: moment().subtract(1, 'month').startOf('month').toISOString(),
        endDate: moment().subtract(1, 'month').endOf('month').toISOString()
    }, DateSlices.day, moment().subtract(1,'month').startOf('month').toDate(), moment().subtract(1,'month').daysInMonth());
    // static readonly YTD = new DateRanges('5', 'Year to date', {
    //     startDate: moment().startOf('year').toISOString(),
    // }, DateSlices.month, moment().startOf('year').toDate(), 12);
    // static readonly ALL_TIME = new DateRanges('6', 'All time', {

    // }, DateSlices.month, moment().toDate(), 12);
    static readonly CUSTOM = new DateRanges('7', 'Custom', {

    }, DateSlices.day, moment().toDate(), 12);

    static readonly values = [
        DateRanges.TODAY,
        DateRanges.THIS_WEEK,
        DateRanges.LAST_WEEK,
        DateRanges.THIS_MONTH,
        DateRanges.LAST_MONTH,
        // DateRanges.YTD,
        // DateRanges.ALL_TIME,
        DateRanges.CUSTOM,
    ];

    static readonly adCampaignValues = [
        DateRanges.THIS_WEEK,
        DateRanges.LAST_WEEK,
        DateRanges.THIS_MONTH,
        DateRanges.LAST_MONTH,
        // DateRanges.YTD,
        DateRanges.CUSTOM,
    ]
}